module.exports = __webpack_public_path__ + "static/media/Erbaum-Bold.550efa4d.woff";